import React from "react";
const ChangePhoneNumber = {
  Title: "Change my phone number",
  MFA:{
  MFATitle : "Two-step verification",
  MFAText:<React.Fragment> If you would like to update the verification phone number used to log in online, call us on <b> 0800 302 9133.</b></React.Fragment>
  }
};

export default ChangePhoneNumber;
